export default "__VITE_ASSET__561e3797__"